export const RO_NO_LABEL = "RO No.";
export const REPAIR_PARTS_ORDER_LABEL = "Repair/Parts Order";
export const START_DATE_LABEL = "Start Date";
export const TECHNICIAN_NAME_LABEL = "Technician Name";
export const CUST_NAME_N_ID_LABEL = "Customer Name with ID";
export const SITE_LOCATION_LABEL = "Site Location";
export const KM_LABEL = "KM";
export const RO_TYPE_LABEL = "Repair Order Type";
export const ENGINE_HOUR_LABEL = "Engine Hour";
export const ACTION_LABEL = "Action";
export const SELECT_LABEL = "Select";
export const SR_NO_LABEL = "Sr. No.";
export const VENDOR_NAME_LABEL = "Vendor Name";
export const VENDOR_ID_LABEL = "Vendor Id";
export const ITEM_CODE_LABEL = "Item Code";
export const ITEM_DESC_LABEL = "Item Description";
export const UOM_LABEL = "UOM";
export const REQUESTED_QTY_LABEL = "Requested Quantity";
export const STOCK_LABEL = "Stock";
export const REQUIRED_STOCK_LABEL = "Required Stock";
export const RATE_LABEL = "Rate";
export const GST_LABEL = "GST";
export const AMOUNT_LABEL = "Amount";
export const STORE_LOCA_LABEL = "Store Location";
export const PROJECT_NAME_LABEL = "Project Name";
export const RACK_LOCA_LABEL = "Rack Location";
export const RAMARKS_LABEL = "Text Document/Remarks";
export const MATERIAL_TYPE_LABEL = "Material Type";
export const MATERIAL_GRP_LABEL = "Material Group";
export const MATERIAL_GRP_DESC_LABEL = "Material Group Description";
export const MATERIAL_DESC_LABEL = "Material Description";
export const PLEASE_SELECT_ONE_ROW = "Please select at least one row.";
export const PR_NO_LABEL = "PR No.";
export const PO_NO_LABEL = "PO No.";
export const PO_DETAILS_LABEL = "Purchase Order Details";
export const TOTAL_AMOUNT_LABEL = "Total Amount";
export const PRODUCT_CODE_LABEL = "Product Code";
export const TOTAL_QTY_LABEL = "Total Quantity";
export const RECEIVED_QTY_LABEL = "Received Quantity";
export const PENDING_QTY_LABEL = "Pending Quantity";
export const ADD_NEW_MAKE = "Add Make";
export const MAKE_KEY = "make";
export const MAKE_NAME = "Make name";
export const PLEASE_ENTER_PROD_DETAILS = "Please enter product details.";
export const PLEASE_ENTER_PROD_DETAILS_FOR_NEW_ROW = "Please enter atleast 1 product details.";
export const ALL_FIELDS_ARE_REQUIRED = "Please fill all required fields.";
export const QTY_GREATER_THAN_ZERO = "Quantity must be greater than 0.";
export const AT_LEAST_ONE_VALID_ISSUE_QTY =
  "At least one part must have a valid issue quantity.";
export const DOCUMENT_DATE_LABEL = "Document Date";
export const HEADER_TEXT_LABEL = "Header Text";
export const ISSUE_DATE_LABEL = "Issue Date";
export const ISSUE_SLIP_NO_LABEL = "Issue Slip No.";
export const ISSUE_QTY_LABEL = "Issue Quantity";
export const ISSUE_QTY_CANNOT_GREATER_REQ_QTY =
  "Issue quantity cannot be greater than requested quantity.";
  export const ISSUE_QTY_CANNOT_GREATER_PENDING_QTY =
  "Issue quantity cannot be greater than pending quantity.";
export const ISSUE_TYPE_LABEL = "Issue Type";
export const RECEIVERS_NAME = "Receiver's Name";
export const TEXT_DOCUMENT_OR_REMARKS = "Text Document or Remarks";
export const RETURN_SPARE_PART = "Return Spare Part";
export const CLOSING_DATE_LABEL = "Closing Date";
export const AUTHORIZED_BY_LABEL = "Authorized By";
export const AT_LEAST_ONE_PART_GREATER_ZERO =
  "At least one part must have a valid quantity greater than zero.";
export const SERVICE_NAME_LABEL = "Service Name";
export const CUST_ID_LABEL = "Customer Id";
export const CUST_NAME_LABEL = "Customer Name";
export const DATE_LABEL = "Date";
export const QTY_LABEL = "Quantity";
export const ARM_LABEL = "Aggregate Repair Measurements";
export const MEASUREMENTS_VALUE = "Measurements Value";
export const AGGREGATE_SR_NO_LABEL = "Aggregate Sr. NO.";
export const VERIFIED_BY_LABEL = "Verified By";
export const TOTAL_WORKING_DAYS_LABEL = "Total Working Days";
export const RETURN_QTY_LABEL = "Return Qty.";
export const REASON_FOR_REOPEN_LABEL = "Reason For Reopen";
export const GENERATE_PR_TITLE = "Generate PR";
export const DO_YOU_WANT_TO_GENERATE_PR_WITH_RO =
  "Do you want to generate PR with RO?";
export const MAKE_LABEL = "Make";
export const PARTS_NAME_LABEL = "Parts Name";
export const PRODUCT_DELETE_SUCCESS = "Product deleted successfully.";
export const INVOICE_ATTACH = "Invoice Attach";
export const REQUESTED_QTY_IS_REQUIRED_VALIDATION =
  "Requested Quantity is required.";
  export const REQUESTED_QTY_IS_GREATER_ZERO =
  "Requested Quantity must be greater than 0.";
export const UPLOAD_LABEL = "Upload";
export const VIEW_FILE_LABEL = "View File";
export const RECEIVED_QTY_CANNOT_EXCEED_PENDING_QTY =
  "Received quantity cannot be greater than pending quantity.";
export const RETURN_QTY_MUST_BE_GREATER_ZERO =
  "Return quantity must be greater than zero.";
export const PO_STATUS_LABEL = "PO Status";
export const PUBLISH_LABEL = "Publish";
export const PUBLISHED_LABEL = "Published";
export const DRAFT_LABEL = "Draft";
export const AT_LEASE_ONE_ROW_HAVE_VALID_RETURN_QTY =
  "At least one row must have a valid return quantity.";
export const PENDING_LABEL = "Pending";
export const RO_NOT_FOUND_LABEL = "Repair order item not found.";
export const CREATED_ON = "Created on";
export const PO_RETURN_STOCK_STATUS = "PO Return Stock Status";
export const RO_RETURN_STOCK_STATUS = "RO Return Stock Status";
export const FULLY_RETURN_LABEL = "Fully Return";
export const PARTIALLY_RETURN_LABEL = "Partially Return";
export const PO_RETURN_LABEL = "Purchase Order Returns";
export const RO_RETURN_LABEL = "Repair Order Returns";
export const RO_RETURN_NUMBER_LABEL = "RO Return Number";
export const RO_RETURN_STATUS_LABEL = "RO Return Status";
export const PO_RETURN_NUMBER_LABEL = "PO Return Number";
export const PO_RETURN_STATUS_LABEL = "PO Return Status";
export const SELECT_ITEM_CODE = "Select Item Code"
export const RECIEVED_QTY_MUST_BE_GREATER_ZERO =
  "Received quantity must be greater than zero.";
  export const REQ_QTY_CANNOT_EXCEED_PENDING_QTY =
  "Quantity should not be greater than Stock.";
  export const PLEASE_ADD_A_PRODUCT = "Please add a product";
  export const PROJECT_NAME_IS_REQUIRED_VALIDATION = "Project Name is required.";
export const GRN_MODULE_LABELS = {
  INVOICE_DATE: "Inovice Date",
  INVOICE_NUMBER: "Invoice Number",
  HEADER_TEXT: "Header Text",
  GATE_ENTRY_NO: "Gate Entry No.",
  GATE_ENTRY_DATE: "Gate Entry Date",
  DMR_NO: "DMR No.",
  DMR_DATE: "DMR Date.",
  TRANSPORTER_NAME: "Transporter Name",
  VEHICLE_NO: "Vehicle No.",
  RECEIPT_BY: "Receipt By",
  LLR_NO: "LLR No.",
  RECEIVED_DATE: "Recieved date",
};
